import {
  AxiosDeleteRequestOptions,
  AxiosGetRequestOptions,
  AxiosPostRequestOptions,
  AxiosPutRequestOptions,
} from '@/package';
import type { LabelingApi } from '@/type';
import { apiOf } from '@/util';

export const getObjectClassList = apiOf<
  LabelingApi.GetObjectClassList.Request,
  LabelingApi.GetObjectClassList.Response
>(
  new AxiosGetRequestOptions({
    url: '/v1/miri/extendClass',
  }),
);

export const getObjectClass = apiOf<
  LabelingApi.GetObjectClass.Request,
  LabelingApi.GetObjectClass.Response
>(
  new AxiosGetRequestOptions({
    url: '/v1/miri/extendClass/:pObjectClassID',
  }),
);

export const getObjectClassCount = apiOf<
  LabelingApi.GetObjectClassCount.Request,
  LabelingApi.GetObjectClassCount.Response
>(
  new AxiosGetRequestOptions({
    url: '/v1/miri/extendClass/count',
  }),
);

export const createObjectClass = apiOf<
  LabelingApi.CreateObjectClass.Request,
  LabelingApi.CreateObjectClass.Response
>(
  new AxiosPostRequestOptions({
    url: '/v1/miri/extendClass',
  }),
);

export const updateObjectClass = apiOf<
  LabelingApi.UpdateObjectClass.Request,
  LabelingApi.UpdateObjectClass.Response
>(
  new AxiosPutRequestOptions({
    url: '/v1/miri/extendClass/:pObjectClassID',
  }),
);

export const reorderExtendClass = apiOf<
  LabelingApi.ReorderExtendClass.Request,
  LabelingApi.ReorderExtendClass.Response
>(
  new AxiosPutRequestOptions({
    url: '/v1/miri/extendClass/:pObjectClassID/reorder',
  }),
);

export const getExtendClassIconList = apiOf<
  LabelingApi.GetExtendClassIconList.Request,
  LabelingApi.GetExtendClassIconList.Response
>(
  new AxiosGetRequestOptions({
    url: '/v1/miri/extendClass/icon',
  }),
);

export const createObjectClassIcon = apiOf<
  LabelingApi.CreateExtendClassIcon.Request,
  LabelingApi.CreateExtendClassIcon.Response
>(
  new AxiosPostRequestOptions({
    url: '/v1/miri/extendClass/icon',
  }),
);

export const updateObjectClassIcon = apiOf<
  LabelingApi.UpdateExtendClassIcon.Request,
  LabelingApi.UpdateExtendClassIcon.Response
>(
  new AxiosPutRequestOptions({
    url: '/v1/miri/extendClass/icon/:pExtendClassIconID',
  }),
);

export const deleteObjectClassIcon = apiOf<
  LabelingApi.DeleteExtendClassIcon.Request,
  LabelingApi.DeleteExtendClassIcon.Response
>(
  new AxiosDeleteRequestOptions({
    url: '/v1/miri/extendClass/icon/:pExtendClassIconID',
  }),
);

export const deleteIcon = apiOf<
  LabelingApi.DeleteIcon.Request,
  LabelingApi.DeleteIcon.Response
>(
  new AxiosDeleteRequestOptions({
    url: '/v1/miri/extendClass/icon/:pIconID',
  }),
);
